import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bdef2ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "category",
  class: "flex-cen category bt-lg-shadow"
}
const _hoisted_2 = { class: "flex viewport" }
const _hoisted_3 = { class: "line--only" }
const _hoisted_4 = { class: "line--only" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "tip text-ct" }

import { t } from '@/plugins/i18n'
import { computed } from 'vue'
import { useStore } from 'vuex'
import MyPopover from '../../common/MyPopover.vue'
import MySwitch from '../../common/MySwitch.vue'
// import CateDropdown from '../common/CateDropdown.vue'
import SecondDrop from './SecondDrop.vue'
import ThirdDrop from './ThirdDrop.vue'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix, useSite2Station } from '@/store'
import { bury } from '@/util/useBury'
import gbk from 'gbk-encode'
import { Site } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { ElMessage } from 'element-plus'

interface S {
  label: string;
  value: string;
  channel: number | string | never;
}

interface C {
  label: string;
  value: string;
  cateNameZh: string;
  cateNameJp: string;
  productCategoryFrontendId: string | number;
  children?: C[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { encode } = gbk
const stationCode = useSite2Station()

const store = useStore()

const buss = store.state.bussiness

const Sellers = computed(() => {
  if (buss.schannel === '0' || buss.schannel === '2' || buss.schannel === '') {
    // 我的频道搜索与透明购一致
    return buss.Sellers
  } else {
    return buss.Sellers.filter(
      (v: S) => buss.schannel ? (!v.channel || v.channel === buss.schannel) : true
    )
  }
})

// const sellers = computed(() => {
//   debugger
//   if (buss.schannel === '0') {
//     // 我的频道搜索与透明购一致
//     return buss.Sellers.filter((v: S) => !v.channel || v.channel === '2')
//   } else {
//     return buss.Sellers.filter(
//       (v: S) => buss.schannel ? (!v.channel || v.channel === buss.schannel) : true
//     )
//   }
// })

// console.log(Sellers, 'sellers').value

const seller = computed({
  get: () => store.state.bussiness.seller,
  set: (v) => store.commit('bussiness/seller', v)
})
const viaCrx = computed({
  get: () => store.getters.viaCrx,
  set: (v) => store.commit('bussiness/viaCrx', v)
})

const cates = computed({
  get: () =>
    buss.fastCates[buss.schannel || '0'] ?? [],
  set: (v) => {
    buss.fastCates[buss.schannel || '0'] = v
    store.commit('bussiness/fastCates', buss.fastCates)
  }
})

const filterCates = computed(() => cates.value.filter((v: any) => v.check))

const update = () => {
  store.commit('bussiness/fastCates', buss.fastCates)
}

const route = useRoute()
const router = useRouter()
const jump = (v: C) => {
  if (v.cateNameJp) {
    bury('ALL_Click_CategoryChose2')
  }
  taTrack({
    event: TaEvent.CATEGORY_CLICK,
    value: {
      category_id: v.productCategoryFrontendId,
      category_name: v.cateNameZh
    }
  })
  if (
    viaCrx.value &&
    seller.value &&
    seller.value !== 'PD') {
    if (!store.getters.isInstall) {
      store.commit('extension/visible', true)
      return
    }
    // 跳转外链
    jumpLinks(v.cateNameZh)
  } else {
    const schannel = Sellers.value.find((i: any) => i.value === seller.value)?.channel ?? ''
    const query: any = {
      productCategoryFrontendId: v.value,
      schannel
    }
    if (seller.value) {
      query.platformType = seller.value
    }
    router[route.name?.toString().includes('list') ? 'replace' : 'push'](
      useRtfix('list', { query })
    )
  }
}
// 跳转外链
const jumpLinks = (key: any) => {
  if (['VC', 'WS'].includes(seller.value) && stationCode === Site.EN) {
    ElMessage.error('Sorry, Easybuy Pluging cannot support WSY/VVIC.')
    return
  }
  const url = buss.externalLinks[seller.value]
  const keyword =
    seller.value === 'AM' ? 'keywords=' + encode(key) : 'q=' + key
  window.open(url + keyword)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SecondDrop, {
        class: "rel seller",
        modelValue: _unref(seller),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(seller) ? (seller).value = $event : null)),
        options: _unref(Sellers)
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_TransitionGroup, {
        tag: "div",
        name: "list",
        class: "flex-ter fx-1 cate-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterCates), (v) => {
            return (_openBlock(), _createBlock(SecondDrop, {
              key: v.label,
              class: "rel fx-1 second-drop",
              options: v.children
            }, {
              item: _withCtx((item) => [
                (item.children?.length)
                  ? (_openBlock(), _createBlock(ThirdDrop, {
                      key: 0,
                      options: item.children,
                      class: "btn second-item",
                      onClick: _withModifiers(($event: any) => (jump(item)), ["stop"])
                    }, {
                      item: _withCtx((item2) => [
                        _createElementVNode("div", {
                          class: "flex line--only third-item",
                          onClick: _withModifiers(($event: any) => (jump(item2)), ["stop"])
                        }, _toDisplayString(item2[
                    {
                      [_unref(Site).JA]: 'cateNameJp',
                      [_unref(Site).KO]: 'cateNameKr',
                      [_unref(Site).EN]: 'cateNameEn',
                    }[_unref(stationCode)]
                    ] ?? v.cateNameZh), 9, _hoisted_5)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(item[
                  {
                    [_unref(Site).JA]: 'cateNameJp',
                    [_unref(Site).KO]: 'cateNameKr',
                    [_unref(Site).EN]: 'cateNameEn',
                  }[_unref(stationCode)]
                  ] ?? v.cateNameZh), 1)
                      ]),
                      _: 2
                    }, 1032, ["options", "onClick"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "flex line--only btn second-item",
                      onClick: ($event: any) => (jump(item))
                    }, _toDisplayString(item.label), 9, _hoisted_6))
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(v[
              {
                [_unref(Site).JA]: 'cateNameJp',
                [_unref(Site).KO]: 'cateNameKr',
                [_unref(Site).EN]: 'cateNameEn',
              }[_unref(stationCode)]
              ] ?? v.cateNameZh), 1)
              ]),
              _: 2
            }, 1032, ["options"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: "btn rel toggle line--only",
        title: _unref(t)('1688、タオバオ、TMALL公式サイト検索')
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('站外搜索')) + " ", 1),
        _createVNode(MySwitch, {
          modelValue: _unref(viaCrx),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(viaCrx) ? (viaCrx).value = $event : null))
        }, null, 8, ["modelValue"])
      ], 8, _hoisted_7),
      _createVNode(MyPopover, {
        list: _unref(cates),
        "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => (_isRef(cates) ? (cates).value = $event : null)),
        width: 260,
        max: 8,
        onChange: update,
        tag: "category"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('请选择你经常使用的类目')), 1)
        ]),
        _: 1
      }, 8, ["list"])
    ])
  ]))
}
}

})